/// <reference path="../../libs.ts" />
import { IMultipleIdsParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IPerformExtractEncryptionActionOnDatasourcesParams extends IMultipleIdsParams {
  type: string;
}

export class PerformExtractEncryptionActionOnDatasourcesRequest extends Request<IPerformExtractEncryptionActionOnDatasourcesParams, IResult> {
  constructor(ids: string[], type: string) {
    super('performExtractEncryptionActionOnDatasources', {
      ids: ids,
      type: type
    });
  }
}
